import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import {TranslateContext} from "../../context/TranslateContext";
import {getMacrocategoriaByIdApi} from "./services/MacrocategorieServices";
import ModificaMacrocategoriaView from "./ModificaMacrocategoriaView";
import FormModificaMacrocategoriaController from "./components/FormModificaMacrocategoriaController";

export default function ModificaMacrocategoriaController() {
    const {id, idClasse} = useParams()

    const [keyTab, setKeyTab] = useState(0);
    const [elemento, setElemento] = useState();

    const {translate} = useContext(TranslateContext);

    const formikRefPrinc = useRef();
    const formikRefFiglio = useRef();
    const history = useHistory();

    var formikRef = formikRefPrinc
    if (keyTab === 'figlio') {
        formikRef = formikRefFiglio
    }

    const getElementoDaModificare = async function () {
        const response = await getMacrocategoriaByIdApi(id);
        let val = response.data.data;

        setElemento(val);

        if (formikRefPrinc.current) {
            formikRefPrinc.current.setFieldValue('id_kpi_macrocategoria', val.id_kpi_macrocategoria);
            formikRefPrinc.current.setFieldValue('id_classe_macrocategoria', val.id_classe_macrocategoria);
            formikRefPrinc.current.setFieldValue('codice', val.codice);
            formikRefPrinc.current.setFieldValue('descrizione', val.descrizione);
            formikRefPrinc.current.setFieldValue('ordine', val.ordine);
            formikRefPrinc.current.setFieldValue('canc', val.canc);
            formikRefPrinc.current.setFieldValue('id_kpi_macrocategoria_madre', val.id_kpi_macrocategoria_madre);
        }
    }

    useEffect(() => {
        if (!idClasse && id && id !== '') {
            getElementoDaModificare();
        }
    }, [id, idClasse]);

    const scrollableTabs = [
        {
            title: translate("Elemento Principale"),
            content: <FormModificaMacrocategoriaController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRefPrinc}
                principale={true}
                elemento={elemento}
            />
        },
        {
            title: translate("Elemento Figlio"),
            content: <FormModificaMacrocategoriaController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRefFiglio}
                principale={false}
                elemento={elemento}
            />
        },
    ];

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    return (
        <ModificaMacrocategoriaView
            translate={translate}
            history={history}
            elemento={elemento}
            id={id}
            idClasse={idClasse}
            keyTab={keyTab}
            scrollableTabs={scrollableTabs}
            setKeyTab={setKeyTab}
            formikRefPrinc={formikRefPrinc}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        />
    );
}